/* tslint:disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v11.7.1.0 (NJsonSchema v9.6.0.0) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import 'rxjs/add/observable/fromPromise';
import 'rxjs/add/observable/of';
import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/catch';

import { Observable } from 'rxjs/Observable';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { Http, Headers, ResponseContentType, Response } from '@angular/http';
import { HydrogenAppConfigService } from '../host.config.service';
export const API_BASE_URL = new InjectionToken('API_BASE_URL');

@Injectable()
export class UserAPIService {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(configSvc: HydrogenAppConfigService, @Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = configSvc.config.serviceUrl.user;
    }

    getNewFeatures(): Observable<NewFeatures> {
        let url_ = this.baseUrl + "/api/NewFeatures/GetNewFeatures";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_) => {
            return this.processGetNewFeatures(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetNewFeatures(response_);
                } catch (e) {
                    return <Observable<NewFeatures>><any>Observable.throw(e);
                }
            } else
                return <Observable<NewFeatures>><any>Observable.throw(response_);
        });
    }

    protected processGetNewFeatures(response: Response): Observable<NewFeatures> {
        const status = response.status;

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? NewFeatures.fromJS(resultData200) : <any>null;
            return Observable.of(result200);
        } else if (status === 500) {
            const _responseText = response.text();
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 ? CustomError.fromJS(resultData500) : <any>null;
            return throwException("A server error occurred.", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<NewFeatures>(<any>null);
    }

    createNewFeature(newFeature: NewFeatures): Observable<NewFeatures> {
        let url_ = this.baseUrl + "/api/NewFeatures/CreateNewFeature";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(newFeature);

        let options_ = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_) => {
            return this.processCreateNewFeature(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateNewFeature(response_);
                } catch (e) {
                    return <Observable<NewFeatures>><any>Observable.throw(e);
                }
            } else
                return <Observable<NewFeatures>><any>Observable.throw(response_);
        });
    }

    protected processCreateNewFeature(response: Response): Observable<NewFeatures> {
        const status = response.status;

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? NewFeatures.fromJS(resultData200) : <any>null;
            return Observable.of(result200);
        } else if (status === 500) {
            const _responseText = response.text();
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 ? CustomError.fromJS(resultData500) : <any>null;
            return throwException("A server error occurred.", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<NewFeatures>(<any>null);
    }

    createUser(hydUser: HydrogenUser): Observable<HydrogenUser> {
        let url_ = this.baseUrl + "/api/user/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(hydUser);

        let options_ = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_) => {
            return this.processCreateUser(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateUser(response_);
                } catch (e) {
                    return <Observable<HydrogenUser>><any>Observable.throw(e);
                }
            } else
                return <Observable<HydrogenUser>><any>Observable.throw(response_);
        });
    }

    protected processCreateUser(response: Response): Observable<HydrogenUser> {
        const status = response.status;

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? HydrogenUser.fromJS(resultData200) : <any>null;
            return Observable.of(result200);
        } else if (status === 500) {
            const _responseText = response.text();
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 ? CustomError.fromJS(resultData500) : <any>null;
            return throwException("A server error occurred.", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<HydrogenUser>(<any>null);
    }

    inviteUser(hydUser: HydrogenUser): Observable<HydrogenUser> {
        let url_ = this.baseUrl + "/api/user/invite";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(hydUser);

        let options_ = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_) => {
            return this.processInviteUser(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processInviteUser(response_);
                } catch (e) {
                    return <Observable<HydrogenUser>><any>Observable.throw(e);
                }
            } else
                return <Observable<HydrogenUser>><any>Observable.throw(response_);
        });
    }

    protected processInviteUser(response: Response): Observable<HydrogenUser> {
        const status = response.status;

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? HydrogenUser.fromJS(resultData200) : <any>null;
            return Observable.of(result200);
        } else if (status === 409) {
            const _responseText = response.text();
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = resultData409 ? CustomError.fromJS(resultData409) : <any>null;
            return throwException("A server error occurred.", status, _responseText, _headers, result409);
        } else if (status === 400) {
            const _responseText = response.text();
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<HydrogenUser>(<any>null);
    }

    updateUser(hydUser: HydrogenUser): Observable<HydrogenUser> {
        let url_ = this.baseUrl + "/api/user/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(hydUser);

        let options_ = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_) => {
            return this.processUpdateUser(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateUser(response_);
                } catch (e) {
                    return <Observable<HydrogenUser>><any>Observable.throw(e);
                }
            } else
                return <Observable<HydrogenUser>><any>Observable.throw(response_);
        });
    }

    protected processUpdateUser(response: Response): Observable<HydrogenUser> {
        const status = response.status;

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? HydrogenUser.fromJS(resultData200) : <any>null;
            return Observable.of(result200);
        } else if (status === 500) {
            const _responseText = response.text();
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 ? CustomError.fromJS(resultData500) : <any>null;
            return throwException("A server error occurred.", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<HydrogenUser>(<any>null);
    }

    updateUserStatus(userId: string, isActive: boolean): Observable<boolean> {
        let url_ = this.baseUrl + "/api/user/UpdateStatus?";
        if (userId === undefined)
            throw new Error("The parameter 'userId' must be defined.");
        else
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (isActive === undefined || isActive === null)
            throw new Error("The parameter 'isActive' must be defined and cannot be null.");
        else
            url_ += "isActive=" + encodeURIComponent("" + isActive) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_) => {
            return this.processUpdateUserStatus(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateUserStatus(response_);
                } catch (e) {
                    return <Observable<boolean>><any>Observable.throw(e);
                }
            } else
                return <Observable<boolean>><any>Observable.throw(response_);
        });
    }

    protected processUpdateUserStatus(response: Response): Observable<boolean> {
        const status = response.status;

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status === 500) {
            const _responseText = response.text();
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 ? CustomError.fromJS(resultData500) : <any>null;
            return throwException("A server error occurred.", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<boolean>(<any>null);
    }

    updateNewFeatureFlag(userId: string): Observable<boolean> {
        let url_ = this.baseUrl + "/api/user/UpdateNewFeatureFlag?";
        if (userId === undefined)
            throw new Error("The parameter 'userId' must be defined.");
        else
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_) => {
            return this.processUpdateNewFeatureFlag(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateNewFeatureFlag(response_);
                } catch (e) {
                    return <Observable<boolean>><any>Observable.throw(e);
                }
            } else
                return <Observable<boolean>><any>Observable.throw(response_);
        });
    }

    protected processUpdateNewFeatureFlag(response: Response): Observable<boolean> {
        const status = response.status;

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status === 500) {
            const _responseText = response.text();
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 ? CustomError.fromJS(resultData500) : <any>null;
            return throwException("A server error occurred.", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<boolean>(<any>null);
    }

    getUsers(search: UserSearch): Observable<HydrogenUser[]> {
        let url_ = this.baseUrl + "/api/user/GetUsers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(search);

        let options_ = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_) => {
            return this.processGetUsers(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetUsers(response_);
                } catch (e) {
                    return <Observable<HydrogenUser[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<HydrogenUser[]>><any>Observable.throw(response_);
        });
    }

    protected processGetUsers(response: Response): Observable<HydrogenUser[]> {
        const status = response.status;

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(HydrogenUser.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status === 500) {
            const _responseText = response.text();
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 ? CustomError.fromJS(resultData500) : <any>null;
            return throwException("A server error occurred.", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<HydrogenUser[]>(<any>null);
    }

    getUserByAccountIDUserID(accountId: string, userId: string): Observable<HydrogenUser> {
        let url_ = this.baseUrl + "/api/user/GetUserByAccountIDUserID?";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined and cannot be null.");
        else
            url_ += "accountId=" + encodeURIComponent("" + accountId) + "&";
        if (userId === undefined)
            throw new Error("The parameter 'userId' must be defined.");
        else
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_) => {
            return this.processGetUserByAccountIDUserID(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetUserByAccountIDUserID(response_);
                } catch (e) {
                    return <Observable<HydrogenUser>><any>Observable.throw(e);
                }
            } else
                return <Observable<HydrogenUser>><any>Observable.throw(response_);
        });
    }

    protected processGetUserByAccountIDUserID(response: Response): Observable<HydrogenUser> {
        const status = response.status;

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? HydrogenUser.fromJS(resultData200) : <any>null;
            return Observable.of(result200);
        } else if (status === 500) {
            const _responseText = response.text();
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 ? CustomError.fromJS(resultData500) : <any>null;
            return throwException("A server error occurred.", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<HydrogenUser>(<any>null);
    }

    getUserById(userId: string): Observable<HydrogenUser> {
        let url_ = this.baseUrl + "/api/user/GetUserById?";
        if (userId === undefined)
            throw new Error("The parameter 'userId' must be defined.");
        else
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_) => {
            return this.processGetUserById(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetUserById(response_);
                } catch (e) {
                    return <Observable<HydrogenUser>><any>Observable.throw(e);
                }
            } else
                return <Observable<HydrogenUser>><any>Observable.throw(response_);
        });
    }

    protected processGetUserById(response: Response): Observable<HydrogenUser> {
        const status = response.status;

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? HydrogenUser.fromJS(resultData200) : <any>null;
            return Observable.of(result200);
        } else if (status === 500) {
            const _responseText = response.text();
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 ? CustomError.fromJS(resultData500) : <any>null;
            return throwException("A server error occurred.", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<HydrogenUser>(<any>null);
    }

    getAllUsersByType(accountid: string, userType: UserTypeEnum): Observable<HydrogenUser[]> {
        let url_ = this.baseUrl + "/api/user/usertype?";
        if (accountid === undefined || accountid === null)
            throw new Error("The parameter 'accountid' must be defined and cannot be null.");
        else
            url_ += "accountid=" + encodeURIComponent("" + accountid) + "&";
        if (userType === undefined || userType === null)
            throw new Error("The parameter 'userType' must be defined and cannot be null.");
        else
            url_ += "userType=" + encodeURIComponent("" + userType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_) => {
            return this.processGetAllUsersByType(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAllUsersByType(response_);
                } catch (e) {
                    return <Observable<HydrogenUser[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<HydrogenUser[]>><any>Observable.throw(response_);
        });
    }

    protected processGetAllUsersByType(response: Response): Observable<HydrogenUser[]> {
        const status = response.status;

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(HydrogenUser.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status === 500) {
            const _responseText = response.text();
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 ? CustomError.fromJS(resultData500) : <any>null;
            return throwException("A server error occurred.", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<HydrogenUser[]>(<any>null);
    }

    deleteUser(userId: string): Observable<boolean> {
        let url_ = this.baseUrl + "/api/user/delete?";
        if (userId === undefined)
            throw new Error("The parameter 'userId' must be defined.");
        else
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_) => {
            return this.processDeleteUser(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteUser(response_);
                } catch (e) {
                    return <Observable<boolean>><any>Observable.throw(e);
                }
            } else
                return <Observable<boolean>><any>Observable.throw(response_);
        });
    }

    protected processDeleteUser(response: Response): Observable<boolean> {
        const status = response.status;

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status === 500) {
            const _responseText = response.text();
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 ? CustomError.fromJS(resultData500) : <any>null;
            return throwException("A server error occurred.", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<boolean>(<any>null);
    }

    hydrogenPortalApplicationRoles(): Observable<AppRole[]> {
        let url_ = this.baseUrl + "/api/user/HydrogenPortalApplicationRoles";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_) => {
            return this.processHydrogenPortalApplicationRoles(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processHydrogenPortalApplicationRoles(response_);
                } catch (e) {
                    return <Observable<AppRole[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<AppRole[]>><any>Observable.throw(response_);
        });
    }

    protected processHydrogenPortalApplicationRoles(response: Response): Observable<AppRole[]> {
        const status = response.status;

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(AppRole.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status === 500) {
            const _responseText = response.text();
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 ? CustomError.fromJS(resultData500) : <any>null;
            return throwException("A server error occurred.", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<AppRole[]>(<any>null);
    }

    domains(): Observable<string[]> {
        let url_ = this.baseUrl + "/api/user/domains";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_) => {
            return this.processDomains(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDomains(response_);
                } catch (e) {
                    return <Observable<string[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<string[]>><any>Observable.throw(response_);
        });
    }

    protected processDomains(response: Response): Observable<string[]> {
        const status = response.status;

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(item);
            }
            return Observable.of(result200);
        } else if (status === 500) {
            const _responseText = response.text();
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 ? CustomError.fromJS(resultData500) : <any>null;
            return throwException("A server error occurred.", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string[]>(<any>null);
    }

    getGroupsByAccountId(accountId: string): Observable<GroupModel[]> {
        let url_ = this.baseUrl + "/api/user/GetGroupsByAccountId?";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined and cannot be null.");
        else
            url_ += "accountId=" + encodeURIComponent("" + accountId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_) => {
            return this.processGetGroupsByAccountId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetGroupsByAccountId(response_);
                } catch (e) {
                    return <Observable<GroupModel[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GroupModel[]>><any>Observable.throw(response_);
        });
    }

    protected processGetGroupsByAccountId(response: Response): Observable<GroupModel[]> {
        const status = response.status;

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GroupModel.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status === 500) {
            const _responseText = response.text();
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 ? CustomError.fromJS(resultData500) : <any>null;
            return throwException("A server error occurred.", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GroupModel[]>(<any>null);
    }

    saveGroupUsers(groupsList: Group[]): Observable<boolean> {
        let url_ = this.baseUrl + "/api/user/SaveGroupUsers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(groupsList);

        let options_ = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_) => {
            return this.processSaveGroupUsers(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSaveGroupUsers(response_);
                } catch (e) {
                    return <Observable<boolean>><any>Observable.throw(e);
                }
            } else
                return <Observable<boolean>><any>Observable.throw(response_);
        });
    }

    protected processSaveGroupUsers(response: Response): Observable<boolean> {
        const status = response.status;

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status === 500) {
            const _responseText = response.text();
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 ? CustomError.fromJS(resultData500) : <any>null;
            return throwException("A server error occurred.", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<boolean>(<any>null);
    }

    checkIsUserNameUnique(userName: string): Observable<boolean> {
        let url_ = this.baseUrl + "/api/user/CheckIsUserNameUnique?";
        if (userName === undefined)
            throw new Error("The parameter 'userName' must be defined.");
        else
            url_ += "userName=" + encodeURIComponent("" + userName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_) => {
            return this.processCheckIsUserNameUnique(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCheckIsUserNameUnique(response_);
                } catch (e) {
                    return <Observable<boolean>><any>Observable.throw(e);
                }
            } else
                return <Observable<boolean>><any>Observable.throw(response_);
        });
    }

    protected processCheckIsUserNameUnique(response: Response): Observable<boolean> {
        const status = response.status;

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status === 500) {
            const _responseText = response.text();
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 ? CustomError.fromJS(resultData500) : <any>null;
            return throwException("A server error occurred.", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<boolean>(<any>null);
    }
}

export class NewFeatures implements INewFeatures {
    id: string;
    content?: string;
    createdBy?: string;
    created: Date;
    lastModifiedBy?: string;
    lastModified?: Date;

    constructor(data?: INewFeatures) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"] !== undefined ? data["id"] : <any>null;
            this.content = data["Content"] !== undefined ? data["Content"] : <any>null;
            this.createdBy = data["CreatedBy"] !== undefined ? data["CreatedBy"] : <any>null;
            this.created = data["Created"] ? new Date(data["Created"].toString()) : <any>null;
            this.lastModifiedBy = data["LastModifiedBy"] !== undefined ? data["LastModifiedBy"] : <any>null;
            this.lastModified = data["LastModified"] ? new Date(data["LastModified"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): NewFeatures {
        let result = new NewFeatures();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["Content"] = this.content !== undefined ? this.content : <any>null;
        data["CreatedBy"] = this.createdBy !== undefined ? this.createdBy : <any>null;
        data["Created"] = this.created ? this.created.toISOString() : <any>null;
        data["LastModifiedBy"] = this.lastModifiedBy !== undefined ? this.lastModifiedBy : <any>null;
        data["LastModified"] = this.lastModified ? this.lastModified.toISOString() : <any>null;
        return data;
    }
}

export interface INewFeatures {
    id: string;
    content?: string;
    createdBy?: string;
    created: Date;
    lastModifiedBy?: string;
    lastModified?: Date;
}

export class CustomError implements ICustomError {
    severity: SeverityEnum;
    statusCode: HttpStatusCode;
    correlationId?: string;
    message?: string;
    exceptionType?: string;

    constructor(data?: ICustomError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.severity = data["Severity"] !== undefined ? data["Severity"] : <any>null;
            this.statusCode = data["StatusCode"] !== undefined ? data["StatusCode"] : <any>null;
            this.correlationId = data["CorrelationId"] !== undefined ? data["CorrelationId"] : <any>null;
            this.message = data["Message"] !== undefined ? data["Message"] : <any>null;
            this.exceptionType = data["ExceptionType"] !== undefined ? data["ExceptionType"] : <any>null;
        }
    }

    static fromJS(data: any): CustomError {
        let result = new CustomError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Severity"] = this.severity !== undefined ? this.severity : <any>null;
        data["StatusCode"] = this.statusCode !== undefined ? this.statusCode : <any>null;
        data["CorrelationId"] = this.correlationId !== undefined ? this.correlationId : <any>null;
        data["Message"] = this.message !== undefined ? this.message : <any>null;
        data["ExceptionType"] = this.exceptionType !== undefined ? this.exceptionType : <any>null;
        return data;
    }
}

export interface ICustomError {
    severity: SeverityEnum;
    statusCode: HttpStatusCode;
    correlationId?: string;
    message?: string;
    exceptionType?: string;
}

export enum SeverityEnum {
    None = 0,
    Warning = 1,
    Error = 2,
    Exception = 3,
}

export enum HttpStatusCode {
    Continue = 100,
    SwitchingProtocols = 101,
    OK = 200,
    Created = 201,
    Accepted = 202,
    NonAuthoritativeInformation = 203,
    NoContent = 204,
    ResetContent = 205,
    PartialContent = 206,
    MultipleChoices = 300,
    Ambiguous = 300,
    MovedPermanently = 301,
    Moved = 301,
    Found = 302,
    Redirect = 302,
    SeeOther = 303,
    RedirectMethod = 303,
    NotModified = 304,
    UseProxy = 305,
    Unused = 306,
    TemporaryRedirect = 307,
    RedirectKeepVerb = 307,
    BadRequest = 400,
    Unauthorized = 401,
    PaymentRequired = 402,
    Forbidden = 403,
    NotFound = 404,
    MethodNotAllowed = 405,
    NotAcceptable = 406,
    ProxyAuthenticationRequired = 407,
    RequestTimeout = 408,
    Conflict = 409,
    Gone = 410,
    LengthRequired = 411,
    PreconditionFailed = 412,
    RequestEntityTooLarge = 413,
    RequestUriTooLong = 414,
    UnsupportedMediaType = 415,
    RequestedRangeNotSatisfiable = 416,
    ExpectationFailed = 417,
    UpgradeRequired = 426,
    InternalServerError = 500,
    NotImplemented = 501,
    BadGateway = 502,
    ServiceUnavailable = 503,
    GatewayTimeout = 504,
    HttpVersionNotSupported = 505,
}

export class HydrogenUser implements IHydrogenUser {
    id?: string;
    firstName?: string;
    middleName?: string;
    lastName?: string;
    email?: string;
    userType: UserTypeEnum;
    userPhone?: string;
    isActive: boolean;
    isDeleted: boolean;
    createdOn: Date;
    modifiedOn: Date;
    lastLogin: Date;
    createdBy?: string;
    modifiedBy?: string;
    role?: string;
    accountId: string;
    tenantVerifiedDomainName?: string;
    userName?: string;
    alertEmail?: string;
    canReceiveAlertEmail?: boolean;
    alertMobilePhone?: string;
    canReceiveAlertSMS?: boolean;
    showWhatsNew?: boolean;
    newFeatureAvailable?: boolean;

    constructor(data?: IHydrogenUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"] !== undefined ? data["id"] : <any>null;
            this.firstName = data["FirstName"] !== undefined ? data["FirstName"] : <any>null;
            this.middleName = data["MiddleName"] !== undefined ? data["MiddleName"] : <any>null;
            this.lastName = data["LastName"] !== undefined ? data["LastName"] : <any>null;
            this.email = data["Email"] !== undefined ? data["Email"] : <any>null;
            this.userType = data["UserType"] !== undefined ? data["UserType"] : <any>null;
            this.userPhone = data["UserPhone"] !== undefined ? data["UserPhone"] : <any>null;
            this.isActive = data["IsActive"] !== undefined ? data["IsActive"] : <any>null;
            this.isDeleted = data["IsDeleted"] !== undefined ? data["IsDeleted"] : <any>null;
            this.createdOn = data["CreatedOn"] ? new Date(data["CreatedOn"].toString()) : <any>null;
            this.modifiedOn = data["ModifiedOn"] ? new Date(data["ModifiedOn"].toString()) : <any>null;
            this.lastLogin = data["LastLogin"] ? new Date(data["LastLogin"].toString()) : <any>null;
            this.createdBy = data["CreatedBy"] !== undefined ? data["CreatedBy"] : <any>null;
            this.modifiedBy = data["ModifiedBy"] !== undefined ? data["ModifiedBy"] : <any>null;
            this.role = data["Role"] !== undefined ? data["Role"] : <any>null;
            this.accountId = data["AccountId"] !== undefined ? data["AccountId"] : <any>null;
            this.tenantVerifiedDomainName = data["TenantVerifiedDomainName"] !== undefined ? data["TenantVerifiedDomainName"] : <any>null;
            this.userName = data["UserName"] !== undefined ? data["UserName"] : <any>null;
            this.alertEmail = data["AlertEmail"] !== undefined ? data["AlertEmail"] : <any>null;
            this.canReceiveAlertEmail = data["CanReceiveAlertEmail"] !== undefined ? data["CanReceiveAlertEmail"] : <any>null;
            this.alertMobilePhone = data["AlertMobilePhone"] !== undefined ? data["AlertMobilePhone"] : <any>null;
            this.canReceiveAlertSMS = data["CanReceiveAlertSMS"] !== undefined ? data["CanReceiveAlertSMS"] : <any>null;
            this.showWhatsNew = data["ShowWhatsNew"] !== undefined ? data["ShowWhatsNew"] : <any>null;
            this.newFeatureAvailable = data["NewFeatureAvailable"] !== undefined ? data["NewFeatureAvailable"] : <any>null;
        }
    }

    static fromJS(data: any): HydrogenUser {
        let result = new HydrogenUser();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["FirstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["MiddleName"] = this.middleName !== undefined ? this.middleName : <any>null;
        data["LastName"] = this.lastName !== undefined ? this.lastName : <any>null;
        data["Email"] = this.email !== undefined ? this.email : <any>null;
        data["UserType"] = this.userType !== undefined ? this.userType : <any>null;
        data["UserPhone"] = this.userPhone !== undefined ? this.userPhone : <any>null;
        data["IsActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        data["IsDeleted"] = this.isDeleted !== undefined ? this.isDeleted : <any>null;
        data["CreatedOn"] = this.createdOn ? this.createdOn.toISOString() : <any>null;
        data["ModifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>null;
        data["LastLogin"] = this.lastLogin ? this.lastLogin.toISOString() : <any>null;
        data["CreatedBy"] = this.createdBy !== undefined ? this.createdBy : <any>null;
        data["ModifiedBy"] = this.modifiedBy !== undefined ? this.modifiedBy : <any>null;
        data["Role"] = this.role !== undefined ? this.role : <any>null;
        data["AccountId"] = this.accountId !== undefined ? this.accountId : <any>null;
        data["TenantVerifiedDomainName"] = this.tenantVerifiedDomainName !== undefined ? this.tenantVerifiedDomainName : <any>null;
        data["UserName"] = this.userName !== undefined ? this.userName : <any>null;
        data["AlertEmail"] = this.alertEmail !== undefined ? this.alertEmail : <any>null;
        data["CanReceiveAlertEmail"] = this.canReceiveAlertEmail !== undefined ? this.canReceiveAlertEmail : <any>null;
        data["AlertMobilePhone"] = this.alertMobilePhone !== undefined ? this.alertMobilePhone : <any>null;
        data["CanReceiveAlertSMS"] = this.canReceiveAlertSMS !== undefined ? this.canReceiveAlertSMS : <any>null;
        data["ShowWhatsNew"] = this.showWhatsNew !== undefined ? this.showWhatsNew : <any>null;
        data["NewFeatureAvailable"] = this.newFeatureAvailable !== undefined ? this.newFeatureAvailable : <any>null;
        return data;
    }
}

export interface IHydrogenUser {
    id?: string;
    firstName?: string;
    middleName?: string;
    lastName?: string;
    email?: string;
    userType: UserTypeEnum;
    userPhone?: string;
    isActive: boolean;
    isDeleted: boolean;
    createdOn: Date;
    modifiedOn: Date;
    lastLogin: Date;
    createdBy?: string;
    modifiedBy?: string;
    role?: string;
    accountId: string;
    tenantVerifiedDomainName?: string;
    userName?: string;
    alertEmail?: string;
    canReceiveAlertEmail?: boolean;
    alertMobilePhone?: string;
    canReceiveAlertSMS?: boolean;
    showWhatsNew?: boolean;
    newFeatureAvailable?: boolean;
}

export enum UserTypeEnum {
    CRESTRON = 0,
    TENANT = 1,
}

export class UserSearch implements IUserSearch {
    accountId: string;
    sortBy?: string;
    page?: number;
    pageSize?: number;
    searchText?: string;

    constructor(data?: IUserSearch) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.accountId = data["AccountId"] !== undefined ? data["AccountId"] : <any>null;
            this.sortBy = data["SortBy"] !== undefined ? data["SortBy"] : <any>null;
            this.page = data["Page"] !== undefined ? data["Page"] : <any>null;
            this.pageSize = data["PageSize"] !== undefined ? data["PageSize"] : <any>null;
            this.searchText = data["SearchText"] !== undefined ? data["SearchText"] : <any>null;
        }
    }

    static fromJS(data: any): UserSearch {
        let result = new UserSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["AccountId"] = this.accountId !== undefined ? this.accountId : <any>null;
        data["SortBy"] = this.sortBy !== undefined ? this.sortBy : <any>null;
        data["Page"] = this.page !== undefined ? this.page : <any>null;
        data["PageSize"] = this.pageSize !== undefined ? this.pageSize : <any>null;
        data["SearchText"] = this.searchText !== undefined ? this.searchText : <any>null;
        return data;
    }
}

export interface IUserSearch {
    accountId: string;
    sortBy?: string;
    page?: number;
    pageSize?: number;
    searchText?: string;
}

export class ComplexTypeBase implements IComplexTypeBase {

    constructor(data?: IComplexTypeBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
        }
    }

    static fromJS(data: any): ComplexTypeBase {
        let result = new ComplexTypeBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IComplexTypeBase {
}

export class AppRole extends ComplexTypeBase implements IAppRole {
    allowedMemberTypes?: string[];
    description?: string;
    displayName?: string;
    id: string;
    isEnabled: boolean;
    value?: string;

    constructor(data?: IAppRole) {
        super(data);
    }

    init(data?: any) {
        super.init(data);
        if (data) {
            if (data["AllowedMemberTypes"] && data["AllowedMemberTypes"].constructor === Array) {
                this.allowedMemberTypes = [];
                for (let item of data["AllowedMemberTypes"])
                    this.allowedMemberTypes.push(item);
            }
            this.description = data["Description"] !== undefined ? data["Description"] : <any>null;
            this.displayName = data["DisplayName"] !== undefined ? data["DisplayName"] : <any>null;
            this.id = data["Id"] !== undefined ? data["Id"] : <any>null;
            this.isEnabled = data["IsEnabled"] !== undefined ? data["IsEnabled"] : <any>null;
            this.value = data["Value"] !== undefined ? data["Value"] : <any>null;
        }
    }

    static fromJS(data: any): AppRole {
        let result = new AppRole();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.allowedMemberTypes && this.allowedMemberTypes.constructor === Array) {
            data["AllowedMemberTypes"] = [];
            for (let item of this.allowedMemberTypes)
                data["AllowedMemberTypes"].push(item);
        }
        data["Description"] = this.description !== undefined ? this.description : <any>null;
        data["DisplayName"] = this.displayName !== undefined ? this.displayName : <any>null;
        data["Id"] = this.id !== undefined ? this.id : <any>null;
        data["IsEnabled"] = this.isEnabled !== undefined ? this.isEnabled : <any>null;
        data["Value"] = this.value !== undefined ? this.value : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IAppRole extends IComplexTypeBase {
    allowedMemberTypes?: string[];
    description?: string;
    displayName?: string;
    id: string;
    isEnabled: boolean;
    value?: string;
}

export class Group implements IGroup {
    type?: string;
    id: string;
    groupName?: string;
    groupParentId?: string;
    accountId?: string;
    policyIds?: string[];
    groupUsers?: GroupUser[];
    isMaintenanceModeEnabled?: boolean;
    tagIds?: string[];
    iconName?: string;
    eTag?: string;

    constructor(data?: IGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.type = data["Type"] !== undefined ? data["Type"] : <any>null;
            this.id = data["id"] !== undefined ? data["id"] : <any>null;
            this.groupName = data["GroupName"] !== undefined ? data["GroupName"] : <any>null;
            this.groupParentId = data["GroupParentId"] !== undefined ? data["GroupParentId"] : <any>null;
            this.accountId = data["AccountId"] !== undefined ? data["AccountId"] : <any>null;
            if (data["PolicyIds"] && data["PolicyIds"].constructor === Array) {
                this.policyIds = [];
                for (let item of data["PolicyIds"])
                    this.policyIds.push(item);
            }
            if (data["GroupUsers"] && data["GroupUsers"].constructor === Array) {
                this.groupUsers = [];
                for (let item of data["GroupUsers"])
                    this.groupUsers.push(GroupUser.fromJS(item));
            }
            this.isMaintenanceModeEnabled = data["IsMaintenanceModeEnabled"] !== undefined ? data["IsMaintenanceModeEnabled"] : <any>null;
            if (data["TagIds"] && data["TagIds"].constructor === Array) {
                this.tagIds = [];
                for (let item of data["TagIds"])
                    this.tagIds.push(item);
            }
            this.iconName = data["IconName"] !== undefined ? data["IconName"] : <any>null;
            this.eTag = data["ETag"] !== undefined ? data["ETag"] : <any>null;
        }
    }

    static fromJS(data: any): Group {
        let result = new Group();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Type"] = this.type !== undefined ? this.type : <any>null;
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["GroupName"] = this.groupName !== undefined ? this.groupName : <any>null;
        data["GroupParentId"] = this.groupParentId !== undefined ? this.groupParentId : <any>null;
        data["AccountId"] = this.accountId !== undefined ? this.accountId : <any>null;
        if (this.policyIds && this.policyIds.constructor === Array) {
            data["PolicyIds"] = [];
            for (let item of this.policyIds)
                data["PolicyIds"].push(item);
        }
        if (this.groupUsers && this.groupUsers.constructor === Array) {
            data["GroupUsers"] = [];
            for (let item of this.groupUsers)
                data["GroupUsers"].push(item.toJSON());
        }
        data["IsMaintenanceModeEnabled"] = this.isMaintenanceModeEnabled !== undefined ? this.isMaintenanceModeEnabled : <any>null;
        if (this.tagIds && this.tagIds.constructor === Array) {
            data["TagIds"] = [];
            for (let item of this.tagIds)
                data["TagIds"].push(item);
        }
        data["IconName"] = this.iconName !== undefined ? this.iconName : <any>null;
        data["ETag"] = this.eTag !== undefined ? this.eTag : <any>null;
        return data;
    }
}

export interface IGroup {
    type?: string;
    id: string;
    groupName?: string;
    groupParentId?: string;
    accountId?: string;
    policyIds?: string[];
    groupUsers?: GroupUser[];
    isMaintenanceModeEnabled?: boolean;
    tagIds?: string[];
    iconName?: string;
    eTag?: string;
}

export class GroupModel extends Group implements IGroupModel {
    accessLevel: AccessLevel;
    minAlertLevel: MinAlertLevel;

    constructor(data?: IGroupModel) {
        super(data);
    }

    init(data?: any) {
        super.init(data);
        if (data) {
            this.accessLevel = data["accessLevel"] !== undefined ? data["accessLevel"] : <any>null;
            this.minAlertLevel = data["minAlertLevel"] !== undefined ? data["minAlertLevel"] : <any>null;
        }
    }

    static fromJS(data: any): GroupModel {
        let result = new GroupModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessLevel"] = this.accessLevel !== undefined ? this.accessLevel : <any>null;
        data["minAlertLevel"] = this.minAlertLevel !== undefined ? this.minAlertLevel : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IGroupModel extends IGroup {
    accessLevel: AccessLevel;
    minAlertLevel: MinAlertLevel;
}

export enum AccessLevel {
    Viewer = 0,
    Tech = 1,
    Administrator = 2,
    Inherit = 3,
    Hidden = 4,
}

export enum MinAlertLevel {
    None = 0,
    Notice = 1,
    Warning = 2,
    Error = 3,
    Critical = 4,
    Inherit = 5,
}

export class GroupUser implements IGroupUser {
    userPrincipalName?: string;
    accessLevel?: AccessLevel;
    minAlertLevel?: MinAlertLevel;

    constructor(data?: IGroupUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userPrincipalName = data["UserPrincipalName"] !== undefined ? data["UserPrincipalName"] : <any>null;
            this.accessLevel = data["AccessLevel"] !== undefined ? data["AccessLevel"] : <any>null;
            this.minAlertLevel = data["MinAlertLevel"] !== undefined ? data["MinAlertLevel"] : <any>null;
        }
    }

    static fromJS(data: any): GroupUser {
        let result = new GroupUser();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["UserPrincipalName"] = this.userPrincipalName !== undefined ? this.userPrincipalName : <any>null;
        data["AccessLevel"] = this.accessLevel !== undefined ? this.accessLevel : <any>null;
        data["MinAlertLevel"] = this.minAlertLevel !== undefined ? this.minAlertLevel : <any>null;
        return data;
    }
}

export interface IGroupUser {
    userPrincipalName?: string;
    accessLevel?: AccessLevel;
    minAlertLevel?: MinAlertLevel;
}

export class SwaggerException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return Observable.throw(result);
    else
        return Observable.throw(new SwaggerException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        let reader = new FileReader();
        reader.onload = function () {
            observer.next(this.result);
            observer.complete();
        }
        reader.readAsText(blob);
    });
}


// WEBPACK FOOTER //
// C:/WS/Fusion/FusionDashboard/src/app/services/Crestron.HydrogenAPI.UserApi.service.ts